define([
    'text!shophall/component/main.html',
    'shophall/common/api',
    'jquery',
    'WebCommon/utils',
    'WebCommon/component/image-link-slick',
    'WebCommon/component/image-360-new20242',

], function(
    tpl,NewApi,$,Utils,
    ImageLinkSlick,
    Image360
){
    return {
        template: tpl,
        components: {
            Image360: Image360,
        },
        data: function(){
            return {
                hallList: [
                    's20480_1722239267_3062.jpg',
                    's20480_1722239344_8261.jpg',
                    's20480_1722239396_2149.jpg',
                    's20480_1722239432_5142.jpg',
                    's20480_1722239474_4569.jpg'
                ],
                id: '',
                info: {},
                showImg: 0,
                isPC: true
            };
        },
        computed: {
            mapWidth: function () {
                return (window.innerWidth-120)*0.4-180;
            },
            mapWidthPhone: function () {
                return (window.innerWidth-120)-160;
            },
            width360: function () {
                return (window.innerWidth-120)*0.6;
            }
        },
        created: function () {
            var obj = this;


        },
        methods: {

            init: function ()
            {
                // var obj = this;
                // NewApi.getShopListApi.ajax({})
                //     .done(function (data) {
                //         obj.shops = data.tableData;
                //     });
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                }else {
                    _this.isPC = true;
                }
                var url = window.location.href;
                var queryList = url.split('?')[1].split('&');
                for(var i=0;i<queryList.length;i++){
                    if (queryList[i].split('=')[0]=='id'){
                        _this.id = queryList[i].split('=')[1];
                        _this.getInfo();
                        return
                    }
                }
            },
            getInfo: function () {
                var _this = this;
                NewApi.getShophallApi.ajax({id:_this.id,lang:_this.$i18n.locale})
                    .done(function(data){
                        _this.info = data.data;
                        _this.hallList = data.data.scenPics.split(';')||[];
                    });
            },
            toImg: function (index) {
                var _this = this;
                _this.showImg = index;
            }

        },
        mounted: function(){
            this.init();
            var obj = this;
            $('.fixed-menu').css({display: 'none'});
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            var image = document.getElementById('draggable-image');
            var container = document.querySelector('.image-container');
            var containerImage = document.querySelector('.draggable-image');
            var dragging = false;
            var currentX, currentY, initialX, initialY, xOffset, yOffset;
            var containerRect = container.getBoundingClientRect();
            var imageRect = image.getBoundingClientRect();

            var mapWidth = 952;
            var mapHeight = 722;

            thex = mapWidth/2;
            they = mapHeight/2;
            xOffset = mapWidth/2;
            yOffset = mapHeight/2;

            image.onmousedown = dragMouseDown;

            window.onmouseup = document.onmouseup = dragMouseUp;
            window.onmousemove = document.onmousemove = dragMouseMove;

            function dragMouseDown(e) {
                e = e || window.event;
                console.log(e.clientX);
                dragging = true;
                console.log('点击鼠标');
                initialX = e.clientX - xOffset;
                initialY = e.clientY - yOffset;
                e.preventDefault();
            }

            function dragMouseMove(e) {
                e = e || window.event;
                if (!dragging) return;

                e.preventDefault();

                // 计算移动的距离
                // var dx = thex + (thex - (e.clientX - initialX));
                // var dy = they + (thex - (e.clientY - initialY));
                var dx = e.clientX - initialX;
                var dy = e.clientY - initialY;
                xOffset = dx;
                yOffset = dy;
                console.log('----------------');
                console.log(dx);
                console.log(dy);
                console.log(xOffset);
                console.log(yOffset);
                console.log('----------------');
                if(xOffset<containerRect.width/2||yOffset<containerRect.height/2||xOffset>(mapWidth-containerRect.width/2)||yOffset>(mapHeight-containerRect.height/2)){
                    if(xOffset<containerRect.width/2){xOffset=containerRect.width/2}
                    if(yOffset<containerRect.height/2){yOffset=containerRect.height/2}
                    if(xOffset>(mapWidth-containerRect.width/2)){xOffset=mapWidth-containerRect.width/2}
                    if(yOffset>(mapHeight-containerRect.height/2)){yOffset=mapHeight-containerRect.height/2}
                    // return
                }
                setTranslate(xOffset, yOffset, image);

                // initialX = e.clientY - xOffset;
                // initialY = e.clientY - yOffset;
            }

            function dragMouseUp(e) {
                console.log('松开鼠标');
                e.preventDefault();
                dragging = false;
            }

            function setTranslate(xPos, yPos, el) {
                el.style.transform = "translate3d(" + -xPos + "px, " + -yPos + "px, 0)";
            }



        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./shophall/component/main.js
// module id = 297
// module chunks = 2